import { defineAction } from '~/prix'
import { z } from 'zod'
import complementaryRoadCreateAction from './complementaryRoadCreate.action.json' with { type: 'json' }
import { complementaryRoadCreateInput, complementaryRoadObject } from '../complementaryRoadObject'

const complementaryRoadCreateDefinition = defineAction({
  ...complementaryRoadCreateAction,
  input: complementaryRoadCreateInput,
  output: z.object({
    id: complementaryRoadObject.shape.id,
  }),
})

export default complementaryRoadCreateDefinition
